import React from 'react';
import { PaymentMethodList } from '../../components/payment-methods/PaymentMethodList';

const PaymentMethodsPage = () => {
    return <PaymentMethodList />;
};

export default PaymentMethodsPage;
